import { useEffect } from "react";

interface UsePageMetaOptions {
  title: string;
  description: string;
}

/**
 * Met à jour le titre de l'onglet et la méta description de la page courante.
 * Chaque page du site possède ainsi un titre et une description uniques,
 * en cohérence avec son contenu réel (amélioration du référencement).
 */
export default function usePageMeta({ title, description }: UsePageMetaOptions) {
  useEffect(() => {
    document.title = title;

    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, [title, description]);
}